// src/echoConfig.js
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import config from "./config";
import SessionUtil from "./util/SessionUtil";
window.Pusher = Pusher;

// console.log(SessionUtil.getToken());
const echo = new Echo({
  broadcaster: "reverb",
  key: "local",
  wsHost: process.env.REACT_APP_WS_HOST || "deliveritdev2.deliverit.cc",
  wsPort: 443,
  wsPath: "/ws",
  forceTLS: true,
  disableStats: true,
  enabledTransports: ["wss", "ws"],
  authEndpoint: `${config.API_URL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${SessionUtil.getToken()}`,
      Accept: 'application/json',
    },
  },
});

export default echo;
